import { render } from "./Ferramentas.vue?vue&type=template&id=26540b57"
import script from "./Ferramentas.vue?vue&type=script&lang=js"
export * from "./Ferramentas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__